import api from '../services/api';
import { IPermission } from '../shared/interfaces';

export const getPermission = async (
  id: string | undefined,
): Promise<IPermission> => {
  if (!id) {
    throw new Error('ID do grupo de acesso não fornecido.');
  }
  const response = await api.get(`/permissions/${id}`);
  return response.data;
};

export const postPermission = async (payload: any): Promise<IPermission> => {
  const response = await api.post(`/permissions`, payload);
  return response.data;
};

export const patchPermission = async (
  id: string | undefined,
  payload: any,
): Promise<IPermission> => {
  if (!id) {
    throw new Error('ID do grupo de acesso não fornecido.');
  }
  const response = await api.patch(`/permissions/${id}`, payload);
  return response.data;
};
